module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_21.108fa51c.jpg";